import { ProvaScritta } from '../../../models/prova-scritta';

export class ProvaScrittaAdapter {

  provaScritta: ProvaScritta = new ProvaScritta();

  constructor(provaScritta: ProvaScritta) {
    this.provaScritta.id = provaScritta.id;
    this.provaScritta.scadenza = provaScritta.scadenza;
    this.provaScritta.descrizione = provaScritta.descrizione;
    this.provaScritta.valore = provaScritta.valore;
    this.provaScritta.note = provaScritta.note;
    this.provaScritta.tipoProvaScritta = provaScritta.tipoProvaScritta ?  JSON.parse(JSON.stringify(provaScritta.tipoProvaScritta)) : null;
    this.provaScritta.documenti = provaScritta.documenti;
  }
}
